import React from "react";
import { phone } from "../Constants/Constants";
import "./OurServices.css";

export default function OurServices() {
  return (
    <>
      <div id="ourservices" className="text-center text-white ourr">
        <h5 data-aos="zoom-in-right" className="heading my-5">
          Our Services
        </h5>
        <div className="container">
          <div className="row align-items-center my-5">
            <div data-aos="zoom-in-up" className="col-md-6 order-1 order-md-1">
              <img
                className="img-fluid rounded"
                src="/Images/bobweb.jpg"
                alt="Web Devlopment"
              />
            </div>
            <div data-aos="zoom-in-up" className="col-md-6 order-2 order-md-2">
              <h1 className="small_heading">Web Development</h1>
              <p className="paragraphs">
                Web design encompasses many different skills and disciplines in
                the production and maintenance of websites. The different areas
                of web design include web graphic design; user interface design
                (UI design); authoring,aspects of the design process, although
                some designers will cover them all.[1] The term "web design" is
                normally used to describe the design process relating to the
                front-end (client side) design of a website including writing
                markup. Web design partially overlaps web engineering in the
                broader scope of web development. Web designers are expected to
                have an awareness of usability and be up to date with web
                accessibility guidelines.
              </p>
              <a href={phone}>
                <button className="caro_Btn">Get your Website Now</button>
              </a>
            </div>
          </div>
          <div className="row align-items-center my-5">
            <div data-aos="zoom-in-up" className="col-md-6 order-2 order-md-1">
              <h1 className="small_heading">App Development</h1>
              <p style={{ fontSize: "1.2em" }} className="small_heading">
                OUR HIGH-END MOBILE APP DEVELOPMENT SERVICES
              </p>
              <p className="paragraphs">
                Mobile app developmentrefers to the process of writing software
                that works on a mobile device (smartphones, tables, wearable).
                But app development is not only about coding a native, HTML5 or
                hybrid app. It is about the strategic process of defining,
                designing, building and launching a successful mobile product.
              </p>
              <a href={phone}>
                <button className="caro_Btn">Get in Touch</button>
              </a>
            </div>
            <div data-aos="zoom-in-up" className="col-md-6 order-1 order-md-2">
              <img
                className="img-fluid rounded"
                src="/Images/bobmob.jpg"
                // src="/Images/bobmo.jpg"
                alt="App Development"
              />
            </div>
          </div>
          <div className="row align-items-center my-5">
            <div data-aos="zoom-in-up" className="col-md-6 order-2 order-md-2">
              <h1 className="small_heading">Graphic Design & Analytics</h1>
              <p className="paragraphs">
                Adobe Photoshop is software that is extensively used for raster
                image editing, graphic design and digital art. It makes use of
                layering to allow for depth and flexibility in the design and
                editing process, as well as provide powerful editing tools, that
                when combined, are capable of just about anything.
              </p>
              <p className="paragraphs"></p>
              <a href={phone}>
                <button className="caro_Btn">
                  Create your unique Identity in the Crowd now
                </button>
              </a>
            </div>
            <div data-aos="zoom-in-up" className="col-md-6 order-1 order-md-1">
              <img
                className="img-fluid rounded"
                src="/Images/bobps.jpg"
                alt="Graphics and Analytics"
              />
            </div>
          </div>
        </div>
      </div>
      <hr style={{ border: "1px solid white" }} className="my-0" />
    </>
  );
}
